import React from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import LogoutPopup from 'apps/auth/components/profile/LogoutPopup';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { NOT_NOW_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { FLOW } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { DOB } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { focusFirstInput } from 'apps/auth/helpers/utils';

const VerifyDetailsModal = (props) => {
    return (
        <>
            <ModalComponent isVerticalCentered canCloseModal={false}>
                <InfoPage
                    insideModalComponent
                    iconName="id-card-80"
                    iconColor="primary"
                    headerText={props.title}
                    secondaryText={props.text}
                    topButtonCaption={props.notNowButton}
                    topButtonType="button"
                    topButtonOnClick={() => {
                        amplitude.getInstance().logEvent(NOT_NOW_CLICKED, { [FLOW]: DOB });
                        props.popupRef.current?.open(<LogoutPopup popupRef={props.popupRef} />);
                    }}
                    primaryButtonCaption={props.buttonContinue}
                    primaryButtonType="button"
                    primaryButtonOnClick={() => {
                        props.modalRef?.current?.close();
                        focusFirstInput();
                    }}
                    primaryButtonDataTestId="dob-info-continue"
                />
            </ModalComponent>
        </>
    );
};

VerifyDetailsModal.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    modalRef: PropTypes.shape({ current: PropTypes.object }),
    title: PropTypes.string,
    text: PropTypes.string,
    notNowButton: PropTypes.string,
    buttonContinue: PropTypes.string,
};

export default VerifyDetailsModal;
